var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CampusRank1"},[_c('div',{staticClass:"titlegaga"},[_vm._v("7日消费数据(金额、订单)")]),_c('div',{attrs:{"id":"MonthRegister"}})])}]

export { render, staticRenderFns }